import SubtitlesPage from './subtitles-page'

export default SubtitlesPage
